/* Earthbound Header V6.1 — premium mobile drawer + merchandising enhancer
   V6.1: leaves a submenu alone when the section already rendered group headings
   (.eb-mobile-menu-group) — i.e. a nested menu or Product columns on the block.
   - Scopes itself from #eb-site-header (no hardcoded Shopify section ID)
   - Keeps Section Store's built-in accessibility / drawer behavior intact
   - Adds mobile Search + Cart, simplified hierarchy, grouped Grounding links,
     compact utility links, product-card formatting and trust messaging.
*/
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function initEarthboundHeaderEnhancer() {
    var root = document.getElementById('eb-site-header');
    if (!root || root.dataset.ebEnhanceV5 === 'true') return;
    root.dataset.ebEnhanceV5 = 'true';

    var headerClass = Array.prototype.find.call(root.classList, function (name) {
      return name.indexOf('header-') === 0;
    });
    if (!headerClass) return;

    var SID = headerClass.replace(/^header-/, '');
    var CFG = window.EB_MENU || {};

    function $(selector, ctx) { return (ctx || root).querySelector(selector); }
    function $$(selector, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(selector)); }
    function cleanText(value) { return (value || '').replace(/\s+/g, ' ').trim(); }

    var sidebarInner = $('.header-menu-sidebar-inner-' + SID);
    var sidebarInnerInner = $('.header-menu-sidebar-inner-inner-' + SID);
    var drawerTop = $('.header-menu-sidebar-top-' + SID);
    var mainNavList = drawerTop && $('.header-menu-list-' + SID, drawerTop);

    if (!sidebarInner || !sidebarInnerInner || !drawerTop || !mainNavList) return;

    function directTriggerText(item) {
      var trigger = item && item.querySelector(':scope > .header-menu-link-' + CSS.escape(SID));
      return trigger ? cleanText(trigger.textContent) : '';
    }

    function findMainItem(title) {
      return $$('.header-menu-item-' + SID, mainNavList).find(function (item) {
        return directTriggerText(item) === title;
      });
    }

    function setTriggerLabel(trigger, label) {
      if (!trigger) return;
      var textNode = Array.prototype.find.call(trigger.childNodes, function (node) {
        return node.nodeType === 3 && cleanText(node.nodeValue);
      });
      if (textNode) textNode.nodeValue = label + ' ';
      else trigger.insertBefore(document.createTextNode(label + ' '), trigger.firstChild);
    }

    function findSubmenuByMainTitle(title) {
      var item = findMainItem(title);
      return item ? item.querySelector('.header-menu-mobile-submenu-' + CSS.escape(SID)) : null;
    }

    function findLinkByText(text, ctx) {
      return $$('a', ctx || root).find(function (link) {
        return cleanText(link.textContent).toLowerCase() === text.toLowerCase();
      });
    }


    /* ----------------------------------------------------------
       2. Drawer top row: Close | centered logo | Search + Cart
       ---------------------------------------------------------- */
    var closeBtn = $('[data-drawer-close]', drawerTop);
    var logoLink = Array.prototype.find.call(drawerTop.children, function (child) {
      return child.tagName === 'A' && child.querySelector('img');
    });

    if (closeBtn && logoLink && !document.getElementById('eb-drawer-top-row')) {
      var topRow = document.createElement('div');
      topRow.id = 'eb-drawer-top-row';
      drawerTop.insertBefore(topRow, closeBtn);
      topRow.appendChild(closeBtn);
      topRow.appendChild(logoLink);

      var actions = document.createElement('div');
      actions.className = 'eb-drawer-actions';

      var desktopSearch = $('.header-right-' + SID + ' .header-search-' + SID);
      var desktopCart = $('.header-right-' + SID + ' .header-cart-' + SID);

      if (desktopSearch) {
        var searchClone = desktopSearch.cloneNode(true);
        searchClone.classList.add('eb-drawer-action');
        searchClone.setAttribute('aria-label', 'Search');
        actions.appendChild(searchClone);
      }
      if (desktopCart) {
        var cartClone = desktopCart.cloneNode(true);
        cartClone.classList.add('eb-drawer-action');
        actions.appendChild(cartClone);
      }

      topRow.appendChild(actions);
    }

    /* ----------------------------------------------------------
       3. Main drawer hierarchy
       Home -> removed (logo is Home)
       FAQs -> merged into Help & Support
       Reviews -> direct destination
       ---------------------------------------------------------- */
    var homeItem = findMainItem('Home');
    if (homeItem) homeItem.hidden = true;

    var faqItem = findMainItem('FAQs');
    var faqSubmenu = faqItem && faqItem.querySelector('.header-menu-mobile-submenu-' + CSS.escape(SID));
    if (faqItem) faqItem.hidden = true;

    var promiseItem = findMainItem('Our Promise');
    var promiseTrigger = promiseItem && promiseItem.querySelector(':scope > .header-menu-link-' + CSS.escape(SID));
    var promiseSubmenu = promiseItem && promiseItem.querySelector('.header-menu-mobile-submenu-' + CSS.escape(SID));
    if (promiseTrigger) setTriggerLabel(promiseTrigger, 'Help & Support');
    if (promiseSubmenu) {
      var promiseHeading = promiseSubmenu.querySelector('.header-menu-mobile-submenu-heading-' + CSS.escape(SID));
      if (promiseHeading) setTriggerLabel(promiseHeading, 'Help & Support');
    }

    var reviewsSource = findLinkByText('Reviews', promiseSubmenu || root);
    var reviewsURL = reviewsSource ? reviewsSource.href : '/pages/reviews';
    if (!mainNavList.querySelector('.eb-mobile-reviews-item')) {
      var reviewsItem = document.createElement('li');
      reviewsItem.className = 'header-menu-item-' + SID + ' eb-mobile-reviews-item';
      reviewsItem.innerHTML = '<a class="header-menu-link-' + SID + '" href="' + reviewsURL + '">Reviews</a>';
      if (promiseItem) mainNavList.insertBefore(reviewsItem, promiseItem);
      else mainNavList.appendChild(reviewsItem);
    }

    /* Merge useful FAQ links into Help, while removing B2B links from shopper nav. */
    if (promiseSubmenu) {
      var helpList = promiseSubmenu.querySelector('.header-mobile-submenu-list-' + CSS.escape(SID));
      if (helpList) {
        $$('.header-menu-item-' + SID, helpList).forEach(function (item) {
          var a = item.querySelector('a');
          var title = a ? cleanText(a.textContent).toLowerCase() : '';
          if (title.indexOf('reviews') !== -1 || title.indexOf('wholesale') !== -1 || title.indexOf('affiliate') !== -1) {
            item.remove();
          }
        });

        if (faqSubmenu) {
          $$('.header-mobile-submenu-list-' + SID + ' a', faqSubmenu).forEach(function (sourceLink) {
            var label = cleanText(sourceLink.textContent);
            var alreadyThere = $$('a', helpList).some(function (link) {
              return cleanText(link.textContent).toLowerCase() === label.toLowerCase();
            });
            if (!alreadyThere) {
              var li = document.createElement('li');
              li.className = 'header-menu-item-' + SID;
              var a = document.createElement('a');
              a.className = 'header-menu-link-' + SID;
              a.href = sourceLink.href;
              a.textContent = label;
              li.appendChild(a);
              helpList.appendChild(li);
            }
          });
        }
      }
    }


    /* Clean Help & Support into two scannable groups. */
    if (promiseSubmenu) {
      var helpListV3 = promiseSubmenu.querySelector('.header-mobile-submenu-list-' + CSS.escape(SID));
      if (helpListV3 && !helpListV3.querySelector('.eb-mobile-menu-group')) {
        var existing = {};
        $$('.header-menu-item-' + SID, helpListV3).forEach(function (item) {
          var a = item.querySelector('a');
          if (!a) return;
          var label = cleanText(a.textContent);
          if (label === 'FSA + HSA') { a.textContent = 'FSA/HSA'; label = 'FSA/HSA'; }
          existing[label] = item;
        });

        function ensureHelpLink(label, href) {
          if (existing[label]) return existing[label];
          var li = document.createElement('li');
          li.className = 'header-menu-item-' + SID;
          var a = document.createElement('a');
          a.className = 'header-menu-link-' + SID;
          a.href = href;
          a.textContent = label;
          li.appendChild(a);
          existing[label] = li;
          return li;
        }

        ensureHelpLink('Track Your Order', '/pages/track-your-order');
        ensureHelpLink('Returns & Exchanges', '/pages/returns-exchanges');
        ensureHelpLink('FSA/HSA', '/pages/fsa-hsa');

        var contact = existing['Contact Us'];
        var trial = existing['90-Night Risk-Free Trial'];
        var warranty = existing['Lifetime Warranty'];
        var about = existing['About Earthbound®'];
        var faq = existing['Frequently Asked Questions'];
        var mattressFaq = existing['Mattress Pad FAQ'];

        helpListV3.innerHTML = '';
        appendHelpGroup('Orders & Support', [
          existing['Track Your Order'],
          existing['Returns & Exchanges'],
          contact,
          existing['FSA/HSA']
        ]);
        appendHelpGroup('Product Help & Policies', [trial, warranty, faq, mattressFaq]);

        function appendHelpGroup(label, items) {
          var heading = document.createElement('li');
          heading.className = 'eb-mobile-menu-group';
          heading.textContent = label;
          helpListV3.appendChild(heading);
          items.forEach(function (item) { if (item) helpListV3.appendChild(item); });
        }
      }
    }

    /* ----------------------------------------------------------
       4. Grounding submenu: Shop All + grouped, scannable categories
       ---------------------------------------------------------- */
    var groundingSubmenu = findSubmenuByMainTitle('Shop Grounding');
    if (groundingSubmenu) {
      var groundingList = groundingSubmenu.querySelector('.header-mobile-submenu-list-' + CSS.escape(SID));
      /* Already grouped by the section (nested menu or Product columns)? Keep it exactly as rendered. */
      if (groundingList && !groundingList.querySelector('.eb-mobile-menu-group')) {
        var itemsByTitle = {};
        $$('.header-menu-item-' + SID, groundingList).forEach(function (item) {
          var link = item.querySelector('a');
          if (link) itemsByTitle[cleanText(link.textContent)] = item;
        });

        function appendGroup(label, titles) {
          var heading = document.createElement('li');
          heading.className = 'eb-mobile-menu-group';
          heading.textContent = label;
          groundingList.appendChild(heading);
          titles.forEach(function (title) {
            if (itemsByTitle[title]) groundingList.appendChild(itemsByTitle[title]);
          });
        }

        groundingList.innerHTML = '';
        if (itemsByTitle['Shop Earthing & Grounding']) {
          var allLink = itemsByTitle['Shop Earthing & Grounding'].querySelector('a');
          if (allLink) {
            allLink.textContent = 'Shop All Grounding';
            allLink.classList.add('eb-shop-all-link');
          }
          groundingList.appendChild(itemsByTitle['Shop Earthing & Grounding']);
        }
        appendGroup('Sleep', ['Mattress Pads', 'Sheets & Bedding', 'Pillow Cases']);
        appendGroup('Everyday', ['Grounding Mats', 'Wearables & Recovery', 'For Pets']);
        appendGroup('More Grounding', ['Bundles & Kits', 'Accessories']);
      }

      /* FAQ is now in Help & Support, so remove duplicated FAQ block here. */
      $$('.header-sidebar-heading-' + SID, groundingSubmenu).forEach(function (heading) {
        if (cleanText(heading.textContent).toLowerCase().indexOf('faq') !== -1) {
          var next = heading.nextElementSibling;
          heading.remove();
          if (next && next.classList.contains('header-sidebar-bottom-' + SID)) next.remove();
        }
      });
    }

    /* ----------------------------------------------------------
       5. Compact high-intent links on the main drawer
       ---------------------------------------------------------- */
    if (!mainNavList.nextElementSibling || !mainNavList.nextElementSibling.classList.contains('eb-mobile-quick-links')) {
      var quickLinks = document.createElement('div');
      quickLinks.className = 'eb-mobile-quick-links';
      quickLinks.innerHTML =
        '<a href="/pages/track-your-order">Track order</a>' +
        '<a href="/pages/returns-exchanges">Returns</a>' +
        '<a href="/pages/fsa-hsa">FSA/HSA</a>';
      mainNavList.insertAdjacentElement('afterend', quickLinks);
    }

    /* ----------------------------------------------------------
       6. Product card title formatting
       ---------------------------------------------------------- */
    $$('.header-sidebar-slide-' + SID).forEach(function (slide) {
      var wrap = slide.querySelector('.header-sidebar-slide-title-' + CSS.escape(SID));
      if (!wrap || wrap.dataset.ebStyled === '1') return;
      var raw = cleanText(wrap.textContent);
      if (!raw) return;
      var parts = raw.split('|').map(function (part) { return cleanText(part); }).filter(Boolean);
      wrap.innerHTML =
        '<p class="eb-slide-name">' + (parts[0] || '') + '</p>' +
        (parts[2] ? '<p class="eb-slide-desc">' + parts[2] + '</p>' : '');
      wrap.dataset.ebStyled = '1';
    });

    /* ----------------------------------------------------------
       7. Compact merchandising labels and context
       ---------------------------------------------------------- */
    var mainSliderWrapper = sidebarInnerInner.querySelector(':scope > .header-sidebar-slider-wrapper-' + CSS.escape(SID));
    if (mainSliderWrapper) {
      mainSliderWrapper.classList.add('eb-main-merch');
      if (!mainSliderWrapper.previousElementSibling || !mainSliderWrapper.previousElementSibling.classList.contains('eb-mobile-merch-head')) {
        var mainHead = document.createElement('div');
        mainHead.className = 'eb-mobile-merch-head';
        mainHead.innerHTML = '<strong>Best sellers</strong><a href="/collections/grounding">Shop all →</a>';
        mainSliderWrapper.parentNode.insertBefore(mainHead, mainSliderWrapper);
      }
    }

    if (groundingSubmenu) {
      var groundingSlider = groundingSubmenu.querySelector('.header-sidebar-slider-wrapper-' + CSS.escape(SID));
      if (groundingSlider) {
        groundingSlider.classList.add('eb-grounding-merch');
        if (!groundingSlider.previousElementSibling || !groundingSlider.previousElementSibling.classList.contains('eb-mobile-merch-head')) {
          var groundingHead = document.createElement('div');
          groundingHead.className = 'eb-mobile-merch-head';
          groundingHead.innerHTML = '<strong>Featured</strong><a href="/products/grounding-mattress-covers">View product →</a>';
          groundingSlider.parentNode.insertBefore(groundingHead, groundingSlider);
        }

        var featuredSlide = groundingSlider.querySelector('.header-sidebar-slide-' + CSS.escape(SID));
        var featuredTitle = featuredSlide && featuredSlide.querySelector('.header-sidebar-slide-title-' + CSS.escape(SID));
        if (featuredTitle && !featuredTitle.querySelector('.eb-feature-benefits-mobile')) {
          var benefits = document.createElement('div');
          benefits.className = 'eb-feature-benefits-mobile';
          benefits.innerHTML =
            '<span class="eb-feature-benefit-mobile">Works through your fitted sheet</span>' +
            '<span class="eb-feature-benefit-mobile">90-night risk-free trial</span>' +
            '<span class="eb-feature-benefit-mobile">FSA/HSA accepted</span>' +
            '<span class="eb-feature-cta-mobile">Shop Mattress Pad →</span>';
          featuredTitle.appendChild(benefits);
        }
      }
    }

    var wellnessSubmenu = findSubmenuByMainTitle('Shop Wellness');
    if (wellnessSubmenu) {
      var wellnessSlider = wellnessSubmenu.querySelector('.header-sidebar-slider-wrapper-' + CSS.escape(SID));
      if (wellnessSlider) wellnessSlider.classList.add('eb-wellness-merch');
    }

    /* ----------------------------------------------------------
       8b. Mobile rail progress indicators
       Gives an immediate visual cue that product rows can be swiped.
       ---------------------------------------------------------- */
    var railUpdaters = [];

    function addRailProgress(wrapper) {
      if (!wrapper || wrapper.classList.contains('eb-grounding-merch')) return;
      var rail = wrapper.querySelector('.header-sidebar-slider-' + CSS.escape(SID));
      var slides = rail && rail.querySelectorAll('.header-sidebar-slide-' + CSS.escape(SID));
      if (!rail || !slides || slides.length < 2) return;
      if (wrapper.querySelector('.eb-mobile-rail-progress')) return;

      var progress = document.createElement('div');
      progress.className = 'eb-mobile-rail-progress';
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span class="eb-mobile-rail-progress__thumb"></span>';
      rail.insertAdjacentElement('afterend', progress);
      var thumb = progress.firstElementChild;

      function updateRailProgress() {
        var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        if (!rail.clientWidth || !rail.scrollWidth || max <= 2) {
          progress.classList.toggle('is-static', !!rail.clientWidth && max <= 2);
          return;
        }
        progress.classList.remove('is-static');
        var visibleRatio = Math.max(.24, Math.min(.62, rail.clientWidth / rail.scrollWidth));
        var thumbPct = visibleRatio * 100;
        var scrollRatio = Math.max(0, Math.min(1, rail.scrollLeft / max));
        thumb.style.width = thumbPct.toFixed(2) + '%';
        thumb.style.left = (scrollRatio * (100 - thumbPct)).toFixed(2) + '%';
      }

      rail.addEventListener('scroll', updateRailProgress, { passive: true });
      rail.addEventListener('touchstart', updateRailProgress, { passive: true });
      railUpdaters.push(updateRailProgress);
      window.requestAnimationFrame(updateRailProgress);
    }

    $$('.header-sidebar-slider-wrapper-' + SID).forEach(addRailProgress);
    window.addEventListener('resize', function () {
      railUpdaters.forEach(function (update) { update(); });
    }, { passive: true });
    root.addEventListener('click', function () {
      window.setTimeout(function () {
        railUpdaters.forEach(function (update) { update(); });
      }, 90);
    });

    /* ----------------------------------------------------------
       9. Trust footer
       ---------------------------------------------------------- */
    function addTrustFooter(container) {
      if (!container || container.querySelector(':scope > .eb-trust-footer')) return;
      var footer = document.createElement('div');
      footer.className = 'eb-trust-footer';
      footer.innerHTML =
        '<span class="eb-trust-item">90-Night Trial</span>' +
        '<span class="eb-trust-dot">·</span>' +
        '<span class="eb-trust-item">Free Shipping $50+</span>' +
        '<span class="eb-trust-dot">·</span>' +
        '<span class="eb-trust-item">Lifetime Warranty</span>';
      container.appendChild(footer);
    }

    addTrustFooter(sidebarInnerInner);
    $$('.header-menu-mobile-submenu-inner-' + SID).forEach(addTrustFooter);

    /* Hide empty promotional wrappers. */
    $$('.header-sidebar-slider-wrapper-' + SID).forEach(function (wrapper) {
      if (!wrapper.querySelector('.header-sidebar-slide-' + CSS.escape(SID))) wrapper.hidden = true;
    });
  });
})();